import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bookmark, Save, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

export const SettingTemplates = ({ mode, settings, onApply }) => {
  const [list, setList] = useState([]);
  const [sel, setSel] = useState("");
  const [name, setName] = useState("");
  const load = () => api.get("/setting-templates").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const mine = list.filter((t) => t.mode === mode);
  const apply = (id) => {
    setSel(id);
    const t = mine.find((x) => x.id === id);
    if (t) { onApply(t.settings); toast.success(`"${t.name}" ayarları uygulandı`); }
  };
  const save = async () => {
    try {
      const { data } = await api.post("/setting-templates", { name: name.trim(), mode, settings });
      setName("");
      await load();
      setSel(data.id);
      toast.success("Ayarlar kaydedildi");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async () => {
    try { await api.delete(`/setting-templates/${sel}`); setSel(""); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-3 space-y-2" data-testid="setting-templates">
      <p className="text-sm font-semibold flex items-center gap-2"><Bookmark className="h-4 w-4 text-[#FACC15]" />Benim ayarlarım</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Select value={sel} onValueChange={apply}>
          <SelectTrigger className="h-10 sm:flex-1" data-testid="setting-template-select">
            <SelectValue placeholder={mine.length ? "Kayıtlı ayarı tek tıkla uygula" : "Bu mod için kayıtlı ayar yok"} />
          </SelectTrigger>
          <SelectContent>{mine.map((t) => <SelectItem key={t.id} value={t.id} data-testid={`setting-template-${t.id}`}>{t.name}</SelectItem>)}</SelectContent>
        </Select>
        {sel && <Button type="button" variant="ghost" size="sm" className="text-red-400 h-10" onClick={remove} data-testid="setting-template-delete"><Trash2 className="h-4 w-4" /></Button>}
      </div>
      <div className="flex gap-2">
        <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={60} placeholder="Şu anki ayarlara ad ver (örn. 9-A hızlı quiz)" className="h-10" data-testid="setting-template-name" />
        <Button type="button" variant="outline" className="h-10" onClick={save} disabled={!name.trim()} data-testid="setting-template-save"><Save className="h-4 w-4 mr-1" />Kaydet</Button>
      </div>
    </div>
  );
};
